<div
	class="c-portlet o-block u-width-100p _u-width-100p u-shadow-mini u-bg-primary c-portlet_box_specs bee-shadow sem-keywords-v3"
	style="position: relative; display: block"
	[ngClass]="{ 'datatable-r10': isR10 }"
>
	<app-loader [showLoader]="showLoad"></app-loader>

	<!-- <div class="c-portlet_box_specs" style="position:relative;"> -->
	<div class="c-portlet__header sem-keywords-header">
		<div class="o-stack__cell">
			<div class="card-title keywords-header primary-color">
				<span *ngIf="sectionclass != 'sem_keywords_R25'">{{ sectiontitle }}</span>
				<h5 *ngIf="sectionclass == 'sem_keywords_R25'">{{ sectiontitle }}</h5>
				<span class="datatable-icon" *ngIf="hasData">
					<a
						href="javascript:void(0)"
						class="datatable_download_icon"
						(click)="downloadCSV($event)"
						target="_blank"
						*ngIf="downloadConfiguration && downloadConfiguration.enableDownload"
					>
						<i class="fa fa-download" aria-hidden="true" *ngIf="!downloadConfiguration.downloadPNG"></i>
						<img
							src="../../../../../assets/images/Download_Icon.svg"
							class="downloadIcon"
							*ngIf="downloadConfiguration.downloadPNG"
						/>
					</a>
				</span>
			</div>
		</div>
	</div>
	<div
		class="analytics-portlet-content sem-keywords-wrapper"
		[ngClass]="{ 'analytics-datatable-scrollable': isVerticalScrollable }"
	>
		<div class="keywords-table-section datatable-v3-content">
			<ngx-datatable
				#myTable
				class="datatable sem-keywords-table v5datatable v5-sem-keywords-table"
				[cssClasses]="isR10 ? cssClassesR10 : cssClassesR5"
				[columnMode]="'force'"
				[headerHeight]="datatableconfig.headerHeight ? datatableconfig.headerHeight : 50"
				[footerHeight]="footerHeight"
				[rowHeight]="datatableconfig.rowHeight ? datatableconfig.rowHeight : 50"
				[rows]="rows"
				[sorts]="defaultSort"
				[reorderable]="false"
				[limit]="datatableconfig.limit ? datatableconfig.limit : paginationLimit"
				[scrollbarV]="isVerticalScrollable"
				[messages]="{ emptyMessage: nodatamessage ? nodatamessage : 'No data to display' }"
				(page)="onPageChange($event)"
				(sort)="sortApplied()"
			>
				<!-- Row Detail Template -->
				<ngx-datatable-row-detail [rowHeight]="innerRowHeight" #myDetailRow>
					<ng-template let-row="row" let-groupedRow="row" let-expanded="expanded" ngx-datatable-row-detail-template>
						<div class="inner-keywords-table v6-sem-inner-table scroll-container">
							<ngx-datatable
								#innerTable
								class="keywords-table"
								[columnMode]="'force'"
								[rowHeight]="datatableconfig.rowHeight ? datatableconfig.rowHeight : 50"
								[rows]="row.keywords"
								[reorderable]="false"
							>
								<ng-template ngFor let-column [ngForOf]="columns">
									<ngx-datatable-column
										[resizeable]="false"
										[sortable]="true"
										[cellClass]="getClassName(column.cellClass)"
										[headerClass]="column.headerClass"
									>
										<ng-template let-row="row" let-columnCell="column" ngx-datatable-cell-template>
											<div class="column-value" *ngIf="column.prop == 'name'; else RegularBlock" [title]="row.keyword">
												<span class="title_18px" [title]="row.keyword">{{ row.keyword }}</span>
											</div>
											<ng-template #RegularBlock>
												<div *ngIf="column.suffix; else RegularRowInnerTable">
													<div class="column-value" *ngIf="!isR10">
														{{
															row[column.prop] > 0
																? row[column.prop] == '100'
																	? 100
																	: (row[column.prop] | number: '0.2-2')
																: '0.00'
														}}%
													</div>
													<div class="column-value" *ngIf="isR10">
														{{
															row[column.prop] > 0
																? row[column.prop] == '100'
																	? 100
																	: row[column.prop]
																: column.name.includes('Top Impression')
																? '0'
																: '0.00'
														}}%
													</div>
												</div>

												<ng-template #RegularRowInnerTable>
													<div *ngIf="column.prop == 'avgPosition'; else NumberCell">
														<span class="title_18px">{{
															row[column.prop] != 0 ? (row[column.prop] | number: '0.2-2') : '--'
														}}</span>
													</div>
													<ng-template #NumberCell>
														<span class="title_18px">{{ row[column.prop] | number }}</span>
													</ng-template>
												</ng-template>
											</ng-template>
										</ng-template>
									</ngx-datatable-column>
								</ng-template>
							</ngx-datatable>
						</div>
					</ng-template>
				</ngx-datatable-row-detail>
				<ng-template ngFor let-column [ngForOf]="columns">
					<ngx-datatable-column
						name="{{ column.name }}"
						prop="{{ column.prop }}"
						[resizeable]="false"
						[sortable]="true"
						[cellClass]="getClassName(column.cellClass)"
						[headerClass]="column.headerClass"
					>
						<ng-template let-colHeader="column" let-sort="sortFn" ngx-datatable-header-template>
							<span
								(click)="sort(); closeRows()"
								style="cursor: pointer"
								*ngIf="!column.columnHasTooltip; else elseBlock"
							>
								{{ colHeader.name }}
							</span>

							<ng-template #elseBlock>
								<span style="cursor: pointer">
									<span
										(click)="sort(); closeRows()"
										appTooltip
										title="Tooltip"
										class="full-text"
										[title]="column.columnTooltip"
										data-size="small"
										[options]="tooltipOptions"
									>
										{{ colHeader.name }}
									</span>
									<span
										(click)="sort(); closeRows()"
										appTooltip
										title="Tooltip"
										class="short-text"
										[title]="column.columnTooltip"
										data-size="small"
										[options]="tooltipOptions"
									>
										{{ column.shortName ? column.shortName : column.name }}
									</span>
								</span>
							</ng-template>
						</ng-template>

						<ng-template let-row="row" let-columnCell="column" ngx-datatable-cell-template>
							<span *ngIf="!isR10">
								<span *ngIf="column.suffix; else RegularRow" class="title_18px"
									>{{ row[column.prop] > 0 ? row[column.prop] : '0.00' }}%</span
								>
							</span>
							<span *ngIf="isR10">
								<span *ngIf="column.suffix; else RegularRow" class="title_18px"
									>{{
										row[column.prop] > 0 ? row[column.prop] : column.name.includes('Top Impression') ? '0' : '0.00'
									}}%</span
								>
							</span>
							<ng-template #RegularRow>
								<div *ngIf="column.prop == 'name'; else RegularCell">
									<div (click)="toggleExpandRow(row)" class="title_18px adgroupname" [title]="row.name">
										{{ row.name }}
									</div>
									<a
										href="javascript:void(0)"
										title="Expand/Collapse Row"
										(click)="toggleExpandRow(row)"
										*ngIf="sectionclass == 'sem_keywords_R25'"
										class="expander"
									>
										<i class="fa fa-angle-right" aria-hidden="true" *ngIf="!row['expand']"></i>
										<i class="fa fa-angle-down" aria-hidden="true" *ngIf="row['expand']"></i>
									</a>
									<a
										class="downwardArrow"
										href="javascript:void(0)"
										title="Expand/Collapse Row"
										(click)="toggleExpandRow(row)"
										*ngIf="sectionclass != 'sem_keywords_R25'"
									>
										<i class="fa fa-angle-down" aria-hidden="true" *ngIf="!row['expand'] && isR10"></i>
										<i class="fa fa-angle-up" aria-hidden="true" *ngIf="row['expand'] && isR10"></i>
										<i class="fa fa-angle-right" aria-hidden="true" *ngIf="!row['expand'] && !isR10"></i>
										<i class="fa fa-angle-down" aria-hidden="true" *ngIf="row['expand'] && !isR10"></i>
									</a>
								</div>
								<ng-template #RegularCell>
									<div *ngIf="column.prop == 'avgPosition'; else NumberCell">
										<span class="title_18px">{{
											row[column.prop] != 0 ? (row[column.prop] | number: '0.2-2') : '--'
										}}</span>
									</div>
									<ng-template #NumberCell>
										<span class="title_18px">{{ row[column.prop] | number }}</span>
									</ng-template>
								</ng-template>
							</ng-template>
						</ng-template>
					</ngx-datatable-column>
				</ng-template>
			</ngx-datatable>
		</div>
	</div>
	<!-- </div> -->
	<!-- when there is no data -->
	<div *ngIf="isR10 && !hasData">
		<div class="no-data-container">
			<h3 class="message">{{ nodatamessage && nodatamessage != 'undefined' ? nodatamessage : 'No Data Available' }}</h3>
		</div>
	</div>
	<!-- END of no data div -->
</div>
